import React, { useState } from "react";
import {
  CancelButton,
  SubmitMapButton,
  BackArrowButton,
  CloseButton,
} from "../../button/Button";
import AddIcon from "../../../assets/icons/addEcl.svg";
import AddField from "../AddField/AddField";
import {CiCircleQuestion} from "react-icons/ci";
import Category from "./Category";
import Currency from "./Currency";
import { updatePayableSubmapping, updateFixedAssetSubMapping } from "../../../../Bookclosure/Services/ApiHandler";
import commonstyles from "../Forms.module.css";
import styles from "./SubMapping.module.css";

export default function Submapping({ onBack, onClose, onCancel, onMapped, PayableID, FixedAssetID }) {
  const [activeTab, setActiveTab] = useState("category");
  const [showAddFieldPopup, setShowAddFieldPopup] = useState(false);
  const [categorySubmap, setCategorySubmap] = useState([]);
  const [currencySubmap, setCurrencySubmap] = useState({});

const handleSubmit = async () => {
  const formattedCurrency = Object.keys(currencySubmap)
    .filter((key) => key.startsWith("closingRate"))
    .map((key) => {
      const currencyKey = key.replace("closingRate", "");
      const rate = Number(currencySubmap[key]) || 0;

      return {
        key: currencyKey,
        values: rate,
      };
    });

  const data = {
    categorySubmap,
    currencySubmap: formattedCurrency,
  };

  try {
    const id = PayableID || FixedAssetID;
    const updateFunction = PayableID ? updatePayableSubmapping : updateFixedAssetSubMapping;
    await updateFunction(id, data);
    if (onMapped) {
      onMapped();
    } else {
      onClose?.();
    }
  } catch (err) {
    console.error("Error updating submapping:", err);
  }
};

  return (
    <>
      <div className={commonstyles.backdrop}>
        <div className={`${commonstyles.container} ${styles.mediumContainer}`}>
          <div className={styles.header}>
            <div className={styles.subheader}>
              <BackArrowButton onClick={onBack} />
              <h2 className={styles.heading}>Sub Mapping</h2>
            </div>

            <div className={styles.headerRight}>
              <div
                className={styles.addSection}
                onClick={() => setShowAddFieldPopup(true)}
              >
                <img src={AddIcon} alt="Add" className={styles.addIcon} />
                <span className={styles.addField}>Add Field</span>
              </div>
              <CloseButton onClick={onClose} />
            </div>
          </div>

          <div className={styles.toggle}>
            <button
              className={`${styles.toggleButton} ${
                activeTab === "category" ? styles.toggleButtonActive : ""
              }`}
              onClick={() => setActiveTab("category")}
            >
              Category
            </button>
            <button
              className={`${styles.toggleButton} ${
                activeTab === "currency" ? styles.toggleButtonActive : ""
              }`}
              onClick={() => setActiveTab("currency")}
            >
              Currency
            </button>
          </div>
           
          <div className={styles.infoBox}>
            <CiCircleQuestion className={styles.infoIcon} />
            <p className={styles.infoText}>
              You may map multiple columns to a single field, but once a column
              is mapped, it cannot be assigned to any other field.
            </p>
          </div>

          <div className={styles.content}>
            {activeTab === "category" ? (
              <Category
                PayableID={PayableID}
                FixedAssetID={FixedAssetID}
                onMappingChange={setCategorySubmap}
              />
            ) : (
              <Currency
                PayableID={PayableID}
                FixedAssetID={FixedAssetID}
                onMappingChange={setCurrencySubmap}
              />
            )}
          </div>

          <div className={commonstyles.footer}>
            <CancelButton onClick={onCancel} />
            <SubmitMapButton onClick={handleSubmit} />
          </div>
        </div>
      </div>

      {showAddFieldPopup && (
        <AddField onClose={() => setShowAddFieldPopup(false)} />
      )}
    </>
  );
}